import React, { useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import Logo from '../assets/khautomationslogoo.png';
import './Navbar.css';

const NavigationBar = () => {
  const [hoveredLink, setHoveredLink] = useState(null);

  const handleMouseEnter = (link) => {
    setHoveredLink(link);
  };

  const handleMouseLeave = () => {
    setHoveredLink(null);
  };

  const renderCard = () => {
    switch (hoveredLink) {
      case 'products':
        return <div className="hover-card">Product 1<br />Product 2<br />Product 3</div>;
      case 'services':
        return <div className="hover-card">Service 1<br />Service 2<br />Service 3</div>;
      case 'about':
        return <div className="hover-card">About Us<br />Our Mission<br />Our Team</div>;
      default:
        return null;
    }
  };

  return (
    <Navbar expand="lg" className="navbar-custom">
      <Navbar.Brand href="/" className="brand-custom">
        <img src={Logo} alt="khautomations" width={100} height={30} />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link as={RouterLink} to="/">
            Home
          </Nav.Link>
          <Nav.Link as={RouterLink} to="/products">
            Products & Services
          </Nav.Link>
          {/* <Nav.Link
            as={ScrollLink}
            to="about"
            smooth={true}
            duration={1000}
            onMouseEnter={() => handleMouseEnter('about')}
            onMouseLeave={handleMouseLeave}
          >
            About
          </Nav.Link> */}
          <Nav.Link as={RouterLink} to="/contactus">
            Contact
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
      {hoveredLink && hoveredLink !== 'contact' && (
        <div className="card-container">{renderCard()}</div>
      )}
    </Navbar>
  );
};

export default NavigationBar;
